import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import GenreOverview from '@/pages/home/components/GenreOverview';
import GuideSection from '@/pages/home/components/GuideSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import LibrarySection from '@/pages/home/components/LibrarySection';
import TvSection from '@/pages/home/components/TvSection';
import FreeSection from '@/pages/home/components/FreeSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CtaBand from '@/pages/home/components/CtaBand';
import FaqSection from '@/pages/home/components/FaqSection';

export default function Home() {
  const [query, setQuery] = useState('');
  const [genre, setGenre] = useState('全部');
  const [kind, setKind] = useState('全部');
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToLibrary = () => {
    const el = document.getElementById('library');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleSearch = (value: string) => {
    setQuery(value);
    scrollToLibrary();
  };

  const handlePickGenre = (nextGenre: string) => {
    setGenre(nextGenre);
    setKind('全部');
    setQuery('');
    scrollToLibrary();
  };

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero onSearch={handleSearch} onPickGenre={handlePickGenre} />
        <GenreOverview onPickGenre={handlePickGenre} />
        <GuideSection />
        <FeaturedSection onPickGenre={handlePickGenre} />
        <LibrarySection
          query={query}
          setQuery={setQuery}
          genre={genre}
          setGenre={setGenre}
          kind={kind}
          setKind={setKind}
        />
        <TvSection onPickGenre={handlePickGenre} />
        <FreeSection onPickGenre={handlePickGenre} />
        <RankingSection onPickGenre={handlePickGenre} />
        <CtaBand />
        <FaqSection />
      </main>
      <Footer />

      {showTop && (
        <button
          type="button"
          aria-label="返回顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </div>
  );
}